/* eslint-disable padding-line-between-statements */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unsafe-optional-chaining */
import React, { useState, useEffect, useCallback, useContext } from 'react';
import _ from 'lodash'
import { useLocation, withRouter, useHistory } from 'react-router-dom';
import { useModal, Loader } from '@jutro/components';
import { withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { Wizard } from '@xengage/gw-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useTranslator } from '@jutro/locale';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { wizardMessages } from 'twia-portals-wizard-components-ui';
import { GatewayEndorsementService as LoadSaveService} from 'twia-capability-gateway-policychange';
import TWIAWizardHelper from 'producer-engage/src/overrides/modules-react/twia-portals-wizard-components-ui/Wizard/components/util/TWIAWizardHelper';
import wizardConfig from './config/tfpa-residential-wizard-config.json5';

// 2024-12-29 - Debra Frum - US29286 - PE - Common - CANCEL PREVIOUS NEXT SAVE&EXIT - Part 2
// Use the new Cancel action added to the Jutro Wizard package in the Kufri version to customize save and exit handling 


const TFPAChangeResidentialWizard = (props) => {
    const [initialSubmission, setInitialSubmission] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const authHeader = _.get(useAuthentication(), 'authHeader');
    const translator = useTranslator();
    const location = useLocation();
    const history = useHistory();
    const { steps, title } = wizardConfig;
    const { viewModelService } = props;
    const { showConfirm,showAlert } = useModal();
    const { jobNumber } = location?.state;
    const { policyNumber } = location?.state;

    // DE17642 If there are multiple policy changes redirect to contact-underwriter view
    const retrieveSubmission =  useCallback(() => {
        if (authHeader) {

            LoadSaveService.loadEndorsement(policyNumber, authHeader).then((response)=>{
                const responseSubmission = viewModelService.create(
                    response, 
                    'pc', 
                    'edge.capabilities.policychange.dto.PolicyChangeDataDTO');
                
                setInitialSubmission(responseSubmission);
                setIsLoading(false);
            }).catch(() => {
                showAlert({
                    title: wizardMessages.TWIAPolicyChangeDraftTitle,
                    message: wizardMessages.TFPAPolicyChangeDraftError,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.close,
                }).then(() => {
                    history.push( `/contactAgent/:policyNumber`, policyNumber);
                },);
            })
        }
    }, [authHeader, history, policyNumber, showAlert, viewModelService]);

    useEffect(()=>{
        retrieveSubmission()
    },[retrieveSubmission])

    if (isLoading) {
        return <Loader loaded={!isLoading} />
    }

    const getSteps = () => {
        const shouldHideStep = initialSubmission?.value?.baseData?.periodStatus === 'Submitted_Ext';

        return shouldHideStep ? steps.filter(step => step.id === 'PaymentDetailsPage' || step.id === 'PaymentDetails') : steps
    }

    // 2024-12-29 - Debra Frum - US29286 - PE - Common - CANCEL PREVIOUS NEXT SAVE&EXIT - Part 2 
    // Use the new Cancel action added to the Jutro Wizard package in the Kufri version to customize save and exit handling 
    const onCancelWithProps = wizardObj => {
        const wizardSnapshot = wizardObj.wizardSnapshot;
        const wizardData = wizardObj.wizardData;
        const path = history.location.pathname
        const jobID = jobNumber ? jobNumber : _.get(wizardData, 'jobID.value')
        const redirectPath = 
            (path === "/endorsement-ho-tfpa/effective-date") || _.isNil(jobID)
            ? _.get(wizardObj, 'param', `/policies/${policyNumber}/summary`)
            : _.get(wizardObj, 'param', `/change/${jobID}/summary`)

        const cancelProps = { wizardSnapshot, wizardData, showConfirm, translator, wizardMessages, setIsLoading, history, redirectPath, authHeader };

        return TWIAWizardHelper.handleCancel(cancelProps);
    }
    return (
        <Wizard
            initialSteps={getSteps()}
            wizardTitle={title}
            initialData={initialSubmission}
            location={location}
            skipCompletedSteps
            onCancel={onCancelWithProps}
        />

    )
}

export default withRouter(withViewModelService(TFPAChangeResidentialWizard));